import { i18n } from '@lingui/core';
import { t } from '../../locales/texts';
import { DEFAULT_AD_IMAGE } from '@finn-no/tjt-common-components';


type Props = {
    img: string | undefined;
    className?: string;
};
const altText = (img: string | undefined) =>
    img ? i18n._(t.adImage.alt) : i18n._(t.adImage.defaultImgAlt);

const AdImage = ({ img, className }: Props) => (
    <img alt={altText(img)} src={img || DEFAULT_AD_IMAGE} className={className} />
);

export default AdImage;
